import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import aside from "../Images/Login-img.png";
import axios from "axios";
import API_URL from "../ServiceModule/Service";
import "./CSS/login.css";
import { BLACK, GRAY_DARK, GRAY_DARL } from "../styles/color";
import GlobalInput from "../components/CustomInput";
import { validateEmail } from "../Utils/Validation";
import CustomButton from "../components/CustomButton";
import google from "../Images/google.png";
import facebook from "../Images/facebook.png";
import apple from "../Images/apple.png";
import { Link, useNavigate } from "react-router-dom";
import {
  auth,
  provider,
  facebookProvider,
} from "../ServiceModule/Firebase";
import { signInWithPopup } from "firebase/auth";
import { useThemeColors } from "../Context/Theme";
import { useDispatch } from "react-redux";
import { loginUser,  verifyUserWithEmail, registerUserWithRoleUser } from "../Features/Auth/AuthSlice";
import { toast,ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import { useGetAPIWithoutTokenQuery, usePostAPIWithTokenMutation } from "../Api/api";
import { READ_ONE_EVENT, RESEND_LINK } from "../Api/apiConstant";
import HomeButton from "../components/HomeButton";
import moment from 'moment-timezone';
import { getToken, getUserId, storeLoggedIn, storeRoleName, storeToken, storeUser, storeUserId,storeRoleId, storeUserLogin } from "./LoginUtility";
import {
  Dialog,
  DialogContent,
  Typography,
  CircularProgress, 
  Button
} from "@mui/material";
import { Grid, Stack } from "@mui/material";


const vliconStyle = {
  position: "absolute",
  top: "74%",
  right: "10px",
  transform: "translateY(-50%)",
  cursor: "pointer",
  color: "#999",
};

const LoginForm = () => {

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isValidEmail, setIsValidEmail] = useState(true);
  const [isValidPassword, setIsValidPassword] = useState(true);
  const [showPassword, setShowPassword] = useState(false);
  const [nameprovider, setnameProvider] = useState("");
  const [fullName, setFullName] = useState("");
  const [Error, setError] = useState({
    email: false,
    password: false,
  });
  const {
    primaryColor,
    secondaryColor,
    textColor,
    buttonColor,
    buttonTextColor,
    backgroundColor,
    logo,
    fontFamily,
    fontWeight,
    fontSize,
    fontFamilyHeading,
    fontWeightHeading,
    fontSizeHeading,
  } = useThemeColors();
  const [loggedIn, setLoggedIn] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const eventName = sessionStorage.getItem("eventName");
  const eventId = sessionStorage.getItem("event_id");
  const [CshowPassword, CsetShowPassword] = React.useState(false);
  const cartId = sessionStorage.getItem("cart_id");
  const userId = getUserId()
  const token = getToken()
  const [isButtonLoading, setIsButtonLoading] = useState(false)
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isVerificationLoading, setIsVerificationLoading] = useState(true);

  const { data } = useGetAPIWithoutTokenQuery(`${READ_ONE_EVENT}${eventId}`);
  // const { data: resendLink } = usePostAPIWithTokenMutation(`${RESEND_LINK}`);

    const [ResendLink] = usePostAPIWithTokenMutation();
  
  const queryParams = new URLSearchParams(window.location.search);
  const tokenParam = queryParams.get("token");

useEffect(() => {
  const verify = async () => {
    if (tokenParam) {
      try {
        const response = await axios.get(
          `${API_URL}/api/users/verifyEmailFromEmail?token=${tokenParam}`
        );
        if (response?.data?.status === true) {
          toast.success(response?.data?.message || "Email verified successfully!");
        } else {
          toast.error(response?.data?.message || "Verification failed.");
          setIsDialogOpen(true);
        }
      } catch (error) {
        console.error("Verification failed:", error.response || error.message || error);
      }
    }
  };
  verify();
}, [tokenParam]);


  //function for email field
  const handleEmailChange = (e) => {
    const emailId = e.target.value;
    setEmail(emailId);
    const isValidEmail = validateEmail(emailId);
    setIsValidEmail(isValidEmail);
    if (!isValidEmail) {
      setIsValidEmail(false);
    } else {
      setIsValidEmail(true);
    }

  };

  const handlePasswordChange = (e) => {
    const newPassword = e.target.value;

    setPassword(newPassword);

  };


  const isFormValid = () => {
    return email && password && isValidEmail
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleCloseDialog = () => {
    setIsDialogOpen(false);
  };

  useEffect(() => {
    if (loggedIn) {
      window.history.pushState(null, null, window.location.href);
      const handlePopState = (event) => {
        if (loggedIn) {
          window.history.pushState(null, null, window.location.href);
        }
      };
      window.addEventListener("popstate", handlePopState);
      return () => {
        window.removeEventListener("popstate", handlePopState);
      };
    }
  }, [loggedIn]);

  useEffect(() => {
    history.replaceState(null, null, `/events/${eventName}/login`);
    history.pushState(null, null, `/events/${eventName}/login`);
  }, [navigate])

  const tz = moment.tz.guess();

  const handleLoginResponse = async (loginResponsePromise) => {
    try {
      const loginResponse = await loginResponsePromise;
      if (loginResponse?.status === true) {
        setLoggedIn(true);
        const roleName = loginResponse?.user?.role_name;
        storeLoggedIn("true");
        storeUserLogin();
        storeUserId(loginResponse?.user?.user_id);
        storeRoleId(loginResponse?.user?.role_id);
        storeRoleId
        storeUser(JSON.stringify(loginResponse?.user));
        storeRoleName(roleName);
        storeToken(loginResponse?.user?.token);
        sessionStorage.setItem("cartId", loginResponse?.user?.cart_id);
        toast.success("Login successful!", {
          autoClose: 1000,
          onClose: () => navigate(`/events/${eventName}`),
        });
      } else {
        setIsButtonLoading(false)
        if (loginResponse.code === "ACCOUNT_LOCKED" && loginResponse.Date) {
          const utcDate = moment.utc(loginResponse.Date);
          const istDate = utcDate.tz('Asia/Kolkata').format("MM-DD-YYYY HH:mm:ss A");
          toast.error(`${loginResponse.message} ${istDate}`);
        } else {
          toast.error(loginResponse?.message || "Invalid Credentials");
        }
        
      }
    }catch (error) {
      setIsButtonLoading(false);
  
      // If backend sends a custom error message
      if (error?.message === "Please verify your account") {
        setIsDialogOpen(true);
      } else {
        toast.error(error?.message || "Invalid Credentials");
      }
    }
  };

  const roleId = 4;

  const handleVerifyGoogle = async (email, username, providerName) => {
    try {
      const nameParts = username.trim().split(" ");
      const first_name = nameParts[0] || "";
      const last_name = nameParts.slice(1).join(" ") || "";

      const registerResponse = await dispatch(
        registerUserWithRoleUser({
          user_email: email.toLowerCase(),
          user_password: password,
          user_name: username,
          role_id: roleId,
          provider_name: providerName,
          first_name: first_name,
          last_name: last_name,
        })
      ).unwrap();
    
      if (registerResponse?.status) {
  
        const loginResponse = await dispatch(
          loginUser({
            user_email: email.toLowerCase(),
            provider_name: providerName,
            event_id: eventId,
          })
        ).unwrap();
        handleLoginResponse(loginResponse);
      } else {
        toast.error("Registration Failed");
      }
    } catch (error) {
      console.error("Error during registration:", error);
      toast.error("Error during registration.");
    }
  };


  const handleUserVerification = async (email) => {
    try {
      const action = verifyUserWithEmail({ user_email: email.toLowerCase() });
      const response = await dispatch(action);
      return response?.payload?.status === false;
    } catch (error) {
      console.error("Error during verification:", error);
      toast.error("An error occurred during verification");
      return false;
    }
  };


  const handleOAuthLogin = async (provider, providerName) => {

    try {
      const result = await signInWithPopup(auth, provider);
      const email = result.user.email;
      const provider_name = result.providerId;
      const username = result.user.displayName;

      sessionStorage.setItem("email", email);
      setEmail(email);
      setFullName(username);
      setnameProvider(provider_name);

      const isRegistered = await handleUserVerification(email);
      if (!isRegistered) {
              // If user is registered, just login
      const loginResponse = dispatch(
        loginUser({
          user_email: email.toLowerCase(),
          provider_name: providerName,
          event_id: eventId,
        })
      ).unwrap()
      handleLoginResponse(loginResponse);

      } else {
       // If user is not registered, register and then login
      await handleVerifyGoogle(email, username, provider_name);
      }
    } catch (error) {
      console.error(`Error during ${providerName} login:`, error);
      // toast.error("Error during authentication!");
    }
  };

  // Google Login Handler
  const handleGoogleLogin = () => {
    handleOAuthLogin(provider, "google.com");
  };

  // Facebook Login Handler

  const handleOAuthLoginFacbook = async (provider, providerName) => {

    try {
      const result = await signInWithPopup(auth, provider);
      const email = result._tokenResponse.email;
      const provider_name = result.providerId;
      const username = result._tokenResponse.displayName;

      sessionStorage.setItem("email", email);
      setEmail(email);
      setFullName(username);
      setnameProvider(provider_name);

      const isRegistered = await handleUserVerification(email);
      if (!isRegistered) {
              // If user is registered, just login
      const loginResponse = dispatch(
        loginUser({
          user_email: email.toLowerCase(),
          provider_name: providerName,
          event_id: eventId,
        })
      ).unwrap()
      handleLoginResponse(loginResponse);

      } else {
       // If user is not registered, register and then login
      await handleVerifyGoogle(email, username, provider_name);
      }
    } catch (error) {
      console.error(`Error during ${providerName} login:`, error);
      if (
        error.message === "Firebase: Error (auth/cancelled-popup-request)." ||
        error.message === "Firebase: Error (auth/popup-closed-by-user)."
      ) {
        return;
      }
      
      toast.error("Error during authentication!");
    }
  };

  const onFacebookButtonPress = () => {
    handleOAuthLoginFacbook(facebookProvider, "facebook.com");
  };

  const CtogglePasswordVisibility = () => {
    CsetShowPassword(!CshowPassword);
  };

  const fcmToken = localStorage.getItem("fcm_token");

  const handleLogin = async () => {

    if (!email && !password) {
      return toast.error("Please fill required fields");
    }
    setIsButtonLoading(true)
    try {
      const loginResponse = dispatch(
        loginUser({
          user_email: email.toLowerCase(),
          user_password: password,
          event_id: eventId,
          fcm_token: fcmToken,
          device_type: "web",
        })
      ).unwrap()
      handleLoginResponse(loginResponse);
    } catch (error) {
      setIsButtonLoading(false)
      console.error("Error during regular login:", error);
      toast.error("Invalid Credential");
    }
  };

  const handleSignUp = () => {
    navigate(`/events/${eventName}/register`);
  };

  const handleResendVerificationEmail = async () => {
    try {
      const response = await ResendLink({
        url: RESEND_LINK,
        formData: {
          email: email.toLowerCase(),
          eventName: eventName,
        }
      }).unwrap();
  
      // Show toast based on backend response status
      if (response?.status === true) {
        toast.success(response?.message || "Verification email resent successfully!", {
          autoClose: 3000,
        });
        handleCloseDialog();
      } else {
        toast.error(response?.message || "Failed to resend verification email.");
        handleCloseDialog();
      }
    } catch (error) {
      console.error("Error resending verification email:", error);
  
      // Optional: handle message from error response if available
      const errorMessage =
        error?.data?.message || error?.message || "Failed to resend verification email.";
      toast.error(errorMessage);
    }
  };
  
  return (
    <React.Fragment>
      <ToastContainer autoClose={1000} />
      <Dialog
  open={isDialogOpen}
  onClose={handleCloseDialog}
  PaperProps={{
    sx: {
      width: 360,
      maxWidth: "90%",
      borderRadius: 3,
      border: "1px solid #e0e0e0",
      boxShadow: 6,
      px: 2,
      py: 3,
    },
  }}
>
  <DialogContent sx={{ textAlign: "center" }}>
    {isVerificationLoading ? (
      <Stack spacing={2} alignItems="center">
        <Typography variant="h6" fontWeight={600}>
        Account Not Active
        </Typography>
        <Typography variant="body2" color="text.secondary">
        Your email is not verified yet. Please check your inbox and verify your account to continue.
        </Typography>
        <Button
          variant="contained"
          onClick={handleResendVerificationEmail}
          sx={{
            mt: 1,
            borderRadius: 2,
            textTransform: "none",
            px: 3,
            py: 1,
          }}
        >
          Resend Verification Email
        </Button>
      </Stack>
    ) : (
      <Stack spacing={2} alignItems="center">
        <Typography variant="h6" fontWeight={600}>
          Email Verified!
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Your email has been successfully verified.
        </Typography>
      </Stack>
    )}
  </DialogContent>
</Dialog>
      <section class="overflow-hidden">
        <div class="container-fluid">
          <div class="row vh-100">
            <div class="col-sm-6 px-0 py-0 m-0 d-none d-sm-block position-relative">
              <div
                style={{
                  position: "relative",
                  width: "100%",
                  height: "100vh",
                }}
              >
                <img
                  src={data?.event_img_path ? data?.event_img_path : aside}
                  alt="Login image"
                  className="w-100 vh-100"
                  style={{
                    objectFit: "cover",
                    objectPosition: "left",
                    margin: "0",
                    overflow: "hidden",
                  }}
                />
                <div
                  style={{
                    position: "absolute",
                    top: "0",
                    left: "0",
                    width: "100%",
                    height: "100%",
                    backgroundColor: "rgba(0, 0, 0, 0.7)",
                  }}
                ></div>
              </div>

              <div class="overlay-content" style={{ width: "100%" }}>
                <img
                  src={logo}
                  alt="Logo"
                  class="logo"
                  width={218}
                  height={142}
                  className="mb-5"
                />
                <p
                  style={{ fontSize: fontSizeHeading || "30px", fontWeight: fontWeightHeading || "700", width: "100%", fontFamily: fontFamilyHeading }}
                  class="heading"
                >
                  Welcome to ORDER THAT
                </p>
                <p
                  style={{
                    fontSize: fontSize || "19px",
                    fontWeight: fontWeight || "500",
                    textAlign: "center",
                    fontFamily
                  }}
                >
                  You're Tailgate Ready with Order That
                </p>
              </div>
            </div>
            <div class="col-sm-6 text-black position-relative">
              <div class="d-flex justify-content-center align-items-center h-custom-2 px-5 ms-xl-4  pt-5 pt-xl-0 mt-xl-n5">
                <form style={{ width: "33rem" }}>
                  <HomeButton text="Home" />
                  <p className="welcome-text" style={{ fontFamily }}>Welcome back!</p>
                  <p class="login-text mb-3 pb-3 fw-bold" style={{ fontFamily: fontFamilyHeading }}>Login</p>

                  <div
                    data-mdb-input-init
                    class="form-outline"
                    style={{ height: "14vh", width: "100%" }}
                  >
                    <GlobalInput
                      type="email"
                      label="E-mail "
                      value={email}
                      onChange={handleEmailChange}
                      placeholder="Enter Email "
                      className={!isValidEmail}

                      required
                      width={"100%"}
                      onBlur={(e) => {
                        const isValid = validateEmail(e.target.value);
                        setError((prevError) => ({
                          ...prevError,
                          email: !isValid,
                        }));
                        setIsValidEmail(isValid);
                      }}
                      style={{ borderColor: !isValidEmail ? "red" : "" }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          handleLogin();
                        }
                      }}
                    />
                    {Error.email && (
                      <div
                        style={{
                          color: "red",
                          fontSize: "0.7em",
                          marginTop: "0.5em",
                        }}
                      >
                        Please Enter a valid Email Address
                      </div>
                    )}
                  </div>
                  <div
                    data-mdb-input-init
                    class="form-outline"
                    style={{ height: "14vh", width: "100%" }}
                  >
                    <GlobalInput
                      type={showPassword ? "text" : "password"}

                      label="Password"
                      value={password}
                      onChange={handlePasswordChange}
                      placeholder="Enter Password"
                      validationMessage={
                        !isValidPassword && password.length > 0
                          ? "Password must be at least 8 characters"
                          : ""
                      }
                      required
                      width={"100%"}
                      endIcon={
                        showPassword ? (
                          <RemoveRedEyeOutlinedIcon
                            style={{ cursor: "pointer", color: "grey" }}
                            onClick={togglePasswordVisibility}
                          />

                        ) : (
                          <VisibilityOffOutlinedIcon
                            style={{ cursor: "pointer", color: "grey" }}
                            onClick={togglePasswordVisibility}
                          />

                        )
                      }
                      style={{ width: "100%" }}
                      onBlur={(e) => {
                        const newPassword = e.target.value;
                        setError((prevError) => ({
                          ...prevError,
                          password: !newPassword,
                        }));
                        setIsValidPassword(newPassword);
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          handleLogin();
                        }
                      }}
                    />
                    {Error.password && (
                      <div
                        style={{
                          color: "red",
                          fontSize: "0.7em",
                          marginTop: "0.5em",
                        }}
                      >
                        Please Enter a valid password
                      </div>
                    )}
                  </div>
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "flex-end",
                    }}
                  >
                    <p
                      class="small text-secondary cursor-pointer"
                      onClick={() => navigate(`/events/${eventName}/forgotPassword`)}
                      style={{
                        cursor: "pointer",
                        width: "max-content",
                        alignSelf: "flex-end",
                        fontFamily
                      }}
                    >
                      Forgot password?
                    </p>
                  </div>
                  <div style={{ width: "100%" }} class="pt-1 mb-4">
                    <CustomButton
                      text="Login"
                      size="lg"
                      block={true}
                      onClick={handleLogin}
                      onLoading={isButtonLoading}
                      disabled={!isFormValid() || isButtonLoading}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" && !isFormValid()) {
                          handleLogin();
                        }
                      }}
                      className="mt-2"
                      width={"100%"}
                    />
                  </div>
                  <div class="d-flex mt-4 align-items-center">
                    <hr class="flex-grow-1 me-4 text-secondary" />
                    <div
                      className=""
                      style={{
                        color: GRAY_DARK,
                        fontSize: "16px",
                        fontWeight: "400",
                        fontFamily
                      }}
                    >
                      or do it via other accounts
                    </div>
                    <hr class="flex-grow-1 ms-4 text-secondary" />
                  </div>
                  <div className="d-flex justify-content-center mt-2">
                    <img
                      onClick={handleGoogleLogin}
                      src={google}
                      className="mr-5 cursor-pointer"
                      style={{ cursor: "pointer" }}
                    />
                    <img src={apple} className="mx-5 cursor-pointer" />
                    <img onClick={onFacebookButtonPress} src={facebook}                       
                    style={{ cursor: "pointer" }}
                    />
                  </div>
                  <p className="text-center fw-bold text-secondary mt-5" style={{ fontFamily, fontWeight }}>
                    Don't have an account?{" "}
                    <span

                      class="link-dark text-dark"
                      style={{ cursor: "pointer", fontFamily, fontWeight }}
                      onClick={handleSignUp}
                    >
                      Sign Up
                    </span>
                  </p>
                </form>
              </div>
              
            </div>
          </div>
        </div>
      
      </section>
    </React.Fragment>
  );
};

export default LoginForm;
